<template>
  <app-content class="h-panel">
    <div class="h-panel-bar"><span class="h-panel-title">资金报表</span></div>
    <Row type="flex" :space-x="10" class="margin-right-left margin-top">
      <Cell>
        <Select v-model="params.accountId" :datas="accountList" keyName="id" titleName="name" :width="160"
                placeholder="全部账户"></Select>
      </Cell>
      <Cell>
        <div class="h-input-group" v-width="320">
          <DatePicker v-model="params.start" style="width: 130px" :clearable="false" :option="{end:params.end}"
                      format="YYYY-MM-DD"></DatePicker>
          <span class="h-input-addon">至</span>
          <DatePicker v-model="params.end" style="width: 130px" :clearable="false" :option="{start:params.start}"
                      format="YYYY-MM-DD"></DatePicker>
        </div>
      </Cell>
      <Cell>
        <Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch">查询</Button>
        <Button icon="fa fa-print" @click="doPrint">打印</Button>
        <Button @click="doExport">导出</Button>
      </Cell>
    </Row>
    <div class="h-panel-body" style="overflow-x: auto;">
      <table class="report-table">
        <thead>
        <tr>
          <th>编码</th>
          <th>账户名称</th>
          <th>期初余额</th>
          <th>收入总额</th>
          <th>支出总额</th>
          <th>余额</th>
          <th>收入笔数</th>
          <th>支出笔数</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in dataList" :key="index">
          <td>{{ item.accountId }}</td>
          <td>{{ item.accountName }}</td>
          <td align="right">{{ item.initialBalance | numFormat }}</td>
          <td align="right">{{ item.incomeAmount | numFormat }}</td>
          <td align="right">{{ item.expenseAmount | numFormat }}</td>
          <td align="right">{{ item.endingBalance | numFormat }}</td>
          <td align="center">{{ item.incomeCount }}</td>
          <td align="center">{{ item.expenseCount }}</td>
        </tr>
        <tr v-if="!dataList.length">
          <td colspan="8" class="text-center padding">暂无数据</td>
        </tr>
        </tbody>
        <tfoot v-if="dataList.length">
        <tr>
          <td colspan="2" align="right"><b>合计</b></td>
          <td align="right">{{ sum('initialBalance') | numFormat }}</td>
          <td align="right">{{ sum('incomeAmount') | numFormat }}</td>
          <td align="right">{{ sum('expenseAmount') | numFormat }}</td>
          <td align="right">{{ sum('endingBalance') | numFormat }}</td>
          <td align="center">{{ sum('incomeCount') }}</td>
          <td align="center">{{ sum('expenseCount') }}</td>
        </tr>
        </tfoot>
      </table>
    </div>
  </app-content>
</template>

<script>
import moment from 'moment';
import {exportCsv} from '../../js/common/export-file';

export default {
  name: 'FundsReport',
  data() {
    return {
      accountList: [],
      dataList: [],
      params: {
        accountId: null,
        type: 'funds',
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment().endOf('month').format('YYYY-MM-DD')
      },
      loading: false
    }
  },
  methods: {
    sum(field) {
      return this.dataList.reduce((total, item) => total + (Number(item[field]) || 0), 0);
    },
    loadBase() {
      this.$api.funds.account.list().then(({data}) => {
        this.accountList = data || [];
      }).catch(() => {
      });
    },
    doSearch() {
      this.loadList();
    },
    loadList() {
      this.loading = true;
      this.$api.funds.report(this.params).then(({data}) => {
        this.dataList = data.results || data || [];
      }).catch(() => {
        this.$Message.error('资金报表加载失败');
      }).finally(() => this.loading = false);
    },
    doPrint() {
      window.print();
    },
    doExport() {
      let headers = ['编码', '账户名称', '期初余额', '收入总额', '支出总额', '余额', '收入笔数', '支出笔数'];
      let rows = this.dataList.map(item => [
        item.accountId, item.accountName, item.initialBalance, item.incomeAmount, item.expenseAmount,
        item.endingBalance, item.incomeCount, item.expenseCount
      ]);
      exportCsv('资金报表', headers, rows);
    }
  },
  mounted() {
    this.loadBase();
    this.loadList();
  }
}
</script>

<style lang="less" scoped>
.report-table {
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 8px 10px;
    border: 1px solid #e2e2e2;
    font-size: 13px;
  }

  th {
    background: #f5f5f5;
    text-align: center;
  }

  tbody tr:nth-child(even) {
    background: #fafafa;
  }

  tfoot td {
    background: #f5f5f5;
  }
}
</style>
